/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cell_Inherited_GrantedInputs */



/**
* | output |
* | --- |
* | "Org default · granted" |
*
* @param {Rights_Cell_Inherited_GrantedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cell_inherited_granted = /** @type {((inputs?: Rights_Cell_Inherited_GrantedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cell_Inherited_GrantedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Org-Standard · gewährt")
	return /** @type {LocalizedString} */ ("Org default · granted")
});